import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-image.tsx
/**
* icon.24.image
*
* Keywords: picture, photo, gallery, landscape, mountain, sun, media, photography
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2IDZhMiAyIDAgMCAxIDIgMnY4YTIgMiAwIDAgMS0yIDJIOGEyIDIgMCAwIDEtMi0yVjhhMiAyIDAgMCAxIDItMnpNOCA3YTEgMSAwIDAgMC0xIDF2OGExIDEgMCAwIDAgMSAxaDhhMSAxIDAgMCAwIDEtMVY4YTEgMSAwIDAgMC0xLTF6bTEuNzI1IDQuNTgyYS41LjUgMCAwIDEgLjYyOS4wNjRsMy41IDMuNWEuNS41IDAgMSAxLS43MDcuNzA3TDEwIDEyLjcwOGwtMS4xNDYgMS4xNDZhLjUuNSAwIDEgMS0uNzA4LS43MDdsMS41LTEuNXpNMTQgOGEyIDIgMCAxIDEgMCA0IDIgMiAwIDAgMSAwLTRtMCAxYTEgMSAwIDEgMCAwIDIgMSAxIDAgMCAwIDAtMiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2913
*/
const Icon24Image = memo(function Icon24Image(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zM8 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm1.725 4.582a.5.5 0 0 1 .629.064l3.5 3.5a.5.5 0 1 1-.707.707L10 12.708l-1.146 1.146a.5.5 0 1 1-.708-.707l1.5-1.5zM14 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
});
//#endregion
export { Icon24Image };

//# sourceMappingURL=icon-24-image.js.map